<template>
  <component
    :is='getComponent'
    :headers='headerWithSumColumn'
    :values='values'
  >
    <template #prepend>
      <slot name='prepend' />
    </template>

    <template #append>
      <slot name='append' />
    </template>
  </component>
</template>

<script>
import FixedSumRowMobile from '@/components/global_components/tables/fixed-sum-row/FixedSumRowMobile';
import FixedSumRowDesktop from '@/components/global_components/tables/fixed-sum-row/FixedSumRowDesktop';

export default {
  name: 'FixedSumRow',
  props: {
    headers: { type: Array, required: true },
    values: { type: Object, default: () => ({}) }
  },
  computed: {
    getComponent() {
      if (this.$vuetify.breakpoint.smAndUp) {
        return FixedSumRowDesktop;
      }
      return FixedSumRowMobile;
    },
    headerWithSumColumn() {
      return this.headers.filter((_header) => this.values[_header.value] != undefined);
    }
  }
};
</script>
